/** Hosted checkout lifetime. */
export const HOSTED_PAYMENT_WINDOW_SECONDS = 30 * 60;

/**
 * Lifetime of the hosted Singapay payment link, which is the wallet hand-off page.
 *
 * This is deliberately not the QRIS window. The hosted page is a different
 * decision: a reminder sent
 * a day later has to point at something still payable, so the page has to
 * outlive the last reminder stage.
 *
 * 24 hours keeps both abandoned-checkout reminders (2h and 24h) inside a window
 * the buyer can still act on.
 */
export const HOSTED_INVOICE_WINDOW_SECONDS = 24 * 60 * 60;

/**
 * Lifetime of an issued bank virtual account.
 *
 * We always send an explicit expiry. 24 hours is the
 * point of the rail: the buyer transfers tonight from their banking app. It
 * also keeps both abandoned-checkout reminders (2h and 24h) inside a window
 * where the number still works.
 */
export const VA_WINDOW_SECONDS = 24 * 60 * 60;

/** Allows final settlement and browser redirect to finish after expiry. */
export const CLAIM_TOKEN_COOKIE_MAX_AGE_SECONDS =
  HOSTED_PAYMENT_WINDOW_SECONDS + 5 * 60;
